import apiClient from "@/app/api/client";
import type { DepartmentGrade, DepartmentGradeFormValues } from "../types";

interface DepartmentGradeListResponse {
	success: true;
	data: DepartmentGrade[];
}

interface SingleDepartmentGradeResponse {
	success: true;
	data: DepartmentGrade;
}

export const departmentGradesService = {
	async list(): Promise<DepartmentGrade[]> {
		const response = await apiClient.get<DepartmentGradeListResponse>("/department-grades");
		return response.data.data;
	},

	async create(input: DepartmentGradeFormValues): Promise<DepartmentGrade> {
		const response = await apiClient.post<SingleDepartmentGradeResponse>(
			"/department-grades",
			input
		);
		return response.data.data;
	},

	async update(id: string, input: Partial<DepartmentGradeFormValues>): Promise<DepartmentGrade> {
		const response = await apiClient.patch<SingleDepartmentGradeResponse>(
			`/department-grades/${id}`,
			input
		);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/department-grades/${id}`);
	},

	async setPositions(id: string, positionIds: string[]): Promise<DepartmentGrade> {
		const response = await apiClient.put<SingleDepartmentGradeResponse>(
			`/department-grades/${id}/positions`,
			{ positionIds }
		);
		return response.data.data;
	},
};
